import { LABELS } from "~/resources/Labels";
import { TemplateResponse } from "~/models/Commons ";
import { SIMPLDialog } from "../.././components/commons/dialog/SimplDialog";

interface DetailProps {
  item?: TemplateResponse;
  onClose: () => void;
  title: string;
}

const labelClass = "font-semibold max-w-[300px]";
export const DetailsVmTemplate = ({ title, item, onClose }: DetailProps) => {
  return (
    <SIMPLDialog onCloseModal={onClose} title={title}>
      <div className="w-auto p-2 pb-5 flex flex-col">
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.Name}</div>
            <div className={""}>{item?.name}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.Description}</div>
            <div className={""}>{item?.description}</div>
          </div>
        </div>
        <div className="flex-1">
          <div className={labelClass}>{LABELS.CloudEnviroment}</div>
          <div className={""}>
            {item?.cloudEnvironment.environmentName}
          </div>
        </div>
        <div className="flex-1">
          <div className={labelClass}>{LABELS.CloudProviderWithSpace}</div>
          <div className={""}>
            {item?.cloudEnvironment.cloudProvider.cloudProviderName}
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.ProvisioningTemplate}</div>
            <div className={""}>
              {item?.cloudProvisionerTemplate.fileName}
            </div>
          </div>
        </div>
        {item?.cloudProvisionerTemplate.ovhFlavor && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{"Ovh Flavor"}</div>
              <div className={""}>
                {item?.cloudProvisionerTemplate.ovhFlavor}
              </div>
            </div>
          </div>
        )}
        {item?.cloudProvisionerTemplate.ovhProjectId && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{"Ovh Project Id"}</div>
              <div className={""}>
                {item?.cloudProvisionerTemplate.ovhProjectId}
              </div>
            </div>
          </div>
        )}
        {item?.cloudProvisionerTemplate.ovhRegion && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{"Ovh Region"}</div>
              <div className={""}>
                {item?.cloudProvisionerTemplate.ovhRegion}
              </div>
            </div>
          </div>
        )}
        {item?.os && (
          <div className="flex flex-row mt-3">
            <div className="flex-1">
              <div className={labelClass}>{LABELS.Os}</div>
              <div className={""}>{item?.os}</div>
            </div>
          </div>
        )}

        {item?.cpuCore && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{LABELS.CpuCore}</div>
              <div className={""}>{item?.cpuCore}</div>
            </div>
          </div>
        )}
        {item?.storage && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{LABELS.Storage}</div>
              <div className={""}>{item?.storage}</div>
            </div>
          </div>
        )}
        {item?.ram && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{LABELS.Ram}</div>
              <div className={""}>{item?.ram}</div>
            </div>
          </div>
        )}
      </div>
    </SIMPLDialog>
  );
};
